import script from "./Shop.vue?vue&type=script&setup=true&lang=js"
export * from "./Shop.vue?vue&type=script&setup=true&lang=js"

import "./Shop.vue?vue&type=style&index=0&id=f8fe749e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8fe749e"]])

export default __exports__